module.exports = __webpack_public_path__ + "img/vegetable-garlic-350x184.a4e8750b.jpg";